(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const page = document.getElementById('asisea-evento-page');
  if (!page) return;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const reveals = qsa('.reveal');
  if ('IntersectionObserver' in window && !reducedMotion) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    reveals.forEach((element) => observer.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }
  window.setTimeout(() => reveals.forEach((element) => element.classList.add('is-visible')), 3000);

  const threadProgress = qs('#thread-progress');
  let scrollFrame = 0;
  const updateScrollProgress = () => {
    scrollFrame = 0;
    if (!threadProgress) return;
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
    threadProgress.style.height = `${progress * 100}%`;
  };
  window.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateScrollProgress);
  }, { passive: true });
  window.addEventListener('resize', updateScrollProgress, { passive: true });
  updateScrollProgress();

  const hero = qs('#hero');
  const heroVisual = qs('#hero-visual');
  const heroTop = qs('#hero-top');
  const scratchHint = qs('#scratch-hint');
  if (hero && heroTop) {
    let hideHintTimer;
    const setMask = (clientX, clientY, radius = 110) => {
      const rect = hero.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;
      const gradient = `radial-gradient(circle ${radius}px at ${x}px ${y}px, transparent 0 60%, #000 100%)`;
      heroTop.style.webkitMaskImage = gradient;
      heroTop.style.maskImage = gradient;
      if (scratchHint) {
        scratchHint.style.opacity = '0';
        window.clearTimeout(hideHintTimer);
        hideHintTimer = window.setTimeout(() => { scratchHint.style.opacity = '1'; }, 1200);
      }
    };
    const resetMask = () => {
      heroTop.style.webkitMaskImage = 'none';
      heroTop.style.maskImage = 'none';
    };
    hero.addEventListener('pointermove', (event) => setMask(event.clientX, event.clientY, event.pointerType === 'touch' ? 88 : 125), { passive: true });
    hero.addEventListener('pointerdown', (event) => setMask(event.clientX, event.clientY, 100), { passive: true });
    hero.addEventListener('pointerleave', resetMask, { passive: true });
    hero.addEventListener('pointerup', (event) => { if (event.pointerType === 'touch') window.setTimeout(resetMask, 450); }, { passive: true });

    if (heroVisual && !reducedMotion && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * -18;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * -12;
        heroVisual.style.transform = `scale(1.04) translate3d(${x}px,${y}px,0)`;
      }, { passive: true });
      hero.addEventListener('pointerleave', () => { heroVisual.style.transform = 'scale(1.04)'; }, { passive: true });
    }
  }

  const heroCta = qs('#hero-cta');
  if (heroCta) {
    heroCta.addEventListener('click', () => {
      const finale = qs('.finale');
      const email = qs('#rsvp-email');
      finale?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(() => email?.focus({ preventScroll: true }), reducedMotion ? 0 : 700);
    });
  }

  const targetDate = new Date('2026-07-28T09:00:00-05:00').getTime();
  const countdowns = qsa('[data-countdown]');
  const updateCountdowns = () => {
    const distance = Math.max(0, targetDate - Date.now());
    const values = {
      days: Math.floor(distance / 86400000),
      hours: Math.floor((distance % 86400000) / 3600000),
      minutes: Math.floor((distance % 3600000) / 60000),
      seconds: Math.floor((distance % 60000) / 1000)
    };
    countdowns.forEach((countdown) => {
      Object.entries(values).forEach(([key, value]) => {
        const field = qs(`[data-${key}]`, countdown);
        if (field) field.textContent = String(value).padStart(2, '0');
      });
    });
  };
  updateCountdowns();
  window.setInterval(updateCountdowns, 1000);

  const galleryTrack = qs('#gallery-track');
  const galleryPrev = qs('#gallery-prev');
  const galleryNext = qs('#gallery-next');
  const galleryProgress = qs('#gallery-progress');
  if (galleryTrack) {
    const getStep = () => {
      const card = qs('.gallery-card', galleryTrack);
      if (!card) return galleryTrack.clientWidth * 0.85;
      const styles = window.getComputedStyle(galleryTrack);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
      return card.getBoundingClientRect().width + gap;
    };
    const updateGalleryState = () => {
      const max = Math.max(1, galleryTrack.scrollWidth - galleryTrack.clientWidth);
      const progress = Math.min(1, Math.max(0, galleryTrack.scrollLeft / max));
      if (galleryProgress) galleryProgress.style.width = `${20 + progress * 80}%`;
      if (galleryPrev) galleryPrev.disabled = galleryTrack.scrollLeft <= 4;
      if (galleryNext) galleryNext.disabled = galleryTrack.scrollLeft >= max - 4;
    };
    galleryPrev?.addEventListener('click', () => galleryTrack.scrollBy({ left: -getStep(), behavior: reducedMotion ? 'auto' : 'smooth' }));
    galleryNext?.addEventListener('click', () => galleryTrack.scrollBy({ left: getStep(), behavior: reducedMotion ? 'auto' : 'smooth' }));
    galleryTrack.addEventListener('scroll', updateGalleryState, { passive: true });
    galleryTrack.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); galleryTrack.scrollBy({ left: -getStep(), behavior: 'smooth' }); }
      if (event.key === 'ArrowRight') { event.preventDefault(); galleryTrack.scrollBy({ left: getStep(), behavior: 'smooth' }); }
    });
    window.addEventListener('resize', updateGalleryState, { passive: true });
    updateGalleryState();
  }

  const soundToggle = qs('#ambient-toggle');
  let audioContext;
  let masterGain;
  let oscillators = [];
  const createAmbientSound = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return false;
    audioContext = new AudioContextClass();
    masterGain = audioContext.createGain();
    masterGain.gain.value = 0;
    masterGain.connect(audioContext.destination);
    [110, 164.81, 220, 277.18].forEach((frequency, index) => {
      const oscillator = audioContext.createOscillator();
      const gain = audioContext.createGain();
      oscillator.type = index % 2 ? 'triangle' : 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.value = 0.035 / (index + 1);
      oscillator.connect(gain);
      gain.connect(masterGain);
      oscillator.start();
      oscillators.push(oscillator);
    });
    return true;
  };
  soundToggle?.addEventListener('click', async () => {
    const shouldTurnOn = soundToggle.getAttribute('aria-pressed') !== 'true';
    if (shouldTurnOn && !audioContext && !createAmbientSound()) {
      soundToggle.querySelector('.sound-label').textContent = 'No disponible';
      return;
    }
    if (audioContext?.state === 'suspended') await audioContext.resume();
    soundToggle.setAttribute('aria-pressed', String(shouldTurnOn));
    soundToggle.classList.toggle('is-on', shouldTurnOn);
    soundToggle.querySelector('.sound-label').textContent = shouldTurnOn ? 'Sonido activo' : 'Sonido apagado';
    if (masterGain && audioContext) {
      masterGain.gain.cancelScheduledValues(audioContext.currentTime);
      masterGain.gain.linearRampToValueAtTime(shouldTurnOn ? 0.45 : 0, audioContext.currentTime + 0.8);
    }
  });

  window.addEventListener('pagehide', () => {
    oscillators.forEach((oscillator) => { try { oscillator.stop(); } catch (_) {} });
    oscillators = [];
    audioContext?.close().catch(() => {});
  }, { once: true });
})();
